export default __webpack_public_path__ + "static/media/battery-quarter-solid.2378ac2d.svg";